import { Component } from '@angular/core';

@Component({
  selector: 'app-email-verification-success',
  imports: [],
  templateUrl: './email-verification-success.component.html',
  styleUrl: './email-verification-success.component.scss'
})
export class EmailVerificationSuccessComponent {

}
